import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "wrapper" };
const _hoisted_2 = { class: "content" };
const _hoisted_3 = { class: "footer" };
const _hoisted_4 = { class: "footer-links" };
import { RouterLink, RouterView } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const year = new Date().getFullYear();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("main", _hoisted_2, [
                    _createVNode(_unref(RouterView))
                ]),
                _createElementVNode("footer", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, [
                        _createVNode(_unref(RouterLink), { to: "/privacy" }, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                    _createTextVNode("Privacy Policy", -1)
                                ]))]),
                            _: 1
                        }),
                        _createVNode(_unref(RouterLink), { to: "/terms" }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                    _createTextVNode("Terms & Conditions", -1)
                                ]))]),
                            _: 1
                        })
                    ]),
                    _createElementVNode("small", null, "© " + _toDisplayString(_unref(year)) + " SIA BaltForge. All rights reserved.", 1)
                ])
            ]));
        };
    }
});
